import { render, staticRenderFns } from "./Insusalidas.vue?vue&type=template&id=2e107a04"
import script from "./Insusalidas.vue?vue&type=script&lang=js"
export * from "./Insusalidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports